import { observable } from "../utils/observer";
import {
  alertConditionsDetailsMapper,
  assignedClientMapper,
  emergencyPlanMapper,
  healthInformationDetailsMapper,
  personalSupportDetailsMapper,
  technologyDetailsMapper,
} from "./wizard";
import { updateAssignedClient } from "./assignedClient";
import { updatePSDetails } from "./personalSupportDetails";
import { updateHIDetails } from "./healthInformationDetails";
import { updateDSDetails } from "./emergencyPlanning";
import { updateTechDetails } from "./technologyDetails";
import { updateACDetails } from "./alertConditionsDetails";

export const saveCarePlan = (clientId) => async (dispatch) => {
  if (Object.keys(observable.notify()).length) {
    // variables
    const carePlan = observable.notify();
    const { prevStep, ref, ACCORDION_LIST } = carePlan;
    const activeElement = ACCORDION_LIST.find(
      (item) => item.stepId === prevStep,
    );
    const activeElementName = activeElement?.elementName;

    if (carePlan && activeElementName && Object.keys(carePlan)?.length > 0) {
      if (activeElementName === "AssignedClientPanel") {
        const assignedClientData = assignedClientMapper(carePlan);
        await dispatch(updateAssignedClient(clientId, assignedClientData));
      } else if (activeElementName === "CareCircle") {
        // triggers submit DD-Board form
        ref?.current?.click();
      } else if (activeElementName === "EmergencyPlanning") {
        const disasterDetails = emergencyPlanMapper(carePlan);
        await dispatch(updateDSDetails(clientId, disasterDetails));
      } else if (activeElementName === "PersonalSupportDetails") {
        const personalSupportDetails = personalSupportDetailsMapper(carePlan);
        await dispatch(updatePSDetails(clientId, personalSupportDetails));
      } else if (activeElementName === "TechnologyDetails") {
        const technologyDetails = technologyDetailsMapper(carePlan);
        await dispatch(updateTechDetails(clientId, technologyDetails));
      } else if (activeElementName === "AlertConditions") {
        const alertConditionsDetails = alertConditionsDetailsMapper(carePlan);
        await dispatch(updateACDetails(clientId, alertConditionsDetails));
      } else if (activeElementName === "HealthInformation") {
        const healthInformationDetails =
          healthInformationDetailsMapper(carePlan);
        await dispatch(updateHIDetails(clientId, healthInformationDetails));
      }
    }
  }
};
